$(document).on("click", ".question_product,.faq_question,.custom_icons_faq_main .icons_with_text_item_title", function (e) {
  if (jQuery(this).hasClass("active")) {
    jQuery(this).toggleClass('active');
    jQuery(this).next().slideToggle();
  } else {
    jQuery('.question_product,.faq_question,.custom_icons_faq_main .icons_with_text_item_title').removeClass('active');
    jQuery('.question_product,.faq_question,.custom_icons_faq_main .icons_with_text_item_title').next().slideUp();
    jQuery(this).toggleClass('active');
    jQuery(this).next().slideToggle();
  }
});





 $(document).on("click", ".custom_button", function (e) {
     var video = jQuery(this).parents('.video_wrapper_custom').find('video');
 if (jQuery(this).hasClass("active")) {
    jQuery(this).parents('.video_wrapper_custom').removeClass('video-active');
     jQuery(this).removeClass('active');
 video.trigger('pause');
 } else {
 video.trigger('play');
   jQuery(this).parents('.video_wrapper_custom').addClass('video-active');
     jQuery(this).addClass('active');
 }
 });







$(document).on("click", "a[href='#compare']", function (e) {
  e.preventDefault();
  document.querySelector('#compare').scrollIntoView({
    behavior: 'smooth'
  })
});

$(document).on("click", "a[href='#reviews']", function (e) {
  e.preventDefault();
  document.querySelector('#reviews').scrollIntoView({
    behavior: 'smooth'
  })
});

$(document).on("click", "a[href='#faq']", function (e) {
  e.preventDefault();
  document.querySelector('#faq').scrollIntoView({
    behavior: 'smooth'
  })
});

$(document).on("click", "a[href='#']", function (e) {
  e.preventDefault();
  document.querySelector('.landing_page_product').scrollIntoView({
    behavior: 'smooth'
  })
});



jQuery(document).ready(function(){
if(navigator.userAgent.indexOf('Mac') > 0) {
jQuery('body').addClass('mac-os');
} else {
jQuery('body').addClass('window-os');
}
});



$(document).on("click", "a[href='#ingredients']", function (e) {
  e.preventDefault();
  document.querySelector('#ingredients').scrollIntoView({
    behavior: 'smooth'
  })
});
$(document).on("click", "a[href='#consistent']", function (e) {
  e.preventDefault();
  document.querySelector('#consistent').scrollIntoView({
    behavior: 'smooth'
  })
});
$(document).on("click", "a[href='#results']", function (e) {
  e.preventDefault();
  document.querySelector('#results').scrollIntoView({
    behavior: 'smooth'
  })
});
















$(document).on("click", ".trigger_tabs_item", function (e) {
var data_tab = $(this).attr('data_tab');
var slider_index = parseInt(data_tab)-1;
$('.tab_item').removeClass('active');
$(this).addClass('active');
$('.richtext_main_slider.slick-slider').slick('slickGoTo', slider_index);
});


$(document).on("click", 'a[href="#show"]', function (e) {
  e.preventDefault();
  $('.show_js').hide();
  $('.hide_js').show();
  $('.BRL_review_list1 .icons_with_text_flex:nth-child(3)~*').show();
});

$(document).on("click", 'a[href="#hide"]', function (e) {
  e.preventDefault();
  $('.show_js').show();
  $('.hide_js').hide();
  $('.BRL_review_list1 .icons_with_text_flex:nth-child(3)~*').hide();
});












